((Weglot) => {
  let slickInitialized = false;

  function initializeSlickSlider(options) {
    // Initialize slick slider with provided options
    jQuery('.slick-container').slick(options);
    slickInitialized = true;
  }

  function languageChangedCallback() {
    const currentLanguage = Weglot.getCurrentLang();

    const slickOptions = {
      dots: true,
      autoplay: true,
      infinite: true,
      speed: 1000,
    };

    if (currentLanguage === 'he') {
      // Set RTL attribute to true for Hebrew language
      slickOptions.rtl = true;
    } else {
      // Remove RTL attribute for other languages
      slickOptions.rtl = false;
    }

    if (slickInitialized) {
      // If slick slider is already initialized, destroy it first
      jQuery('.slick-container').slick('unslick');
    }

    // Initialize slick slider with updated options
    initializeSlickSlider(slickOptions);
  }

  // Initialize slick slider when the page first loads
  initializeSlickSlider({
    dots: true,
    autoplay: true,
    infinite: true,
    speed: 1000,
  });

  // Listen for language change events
  Weglot.on('languageChanged', languageChangedCallback);
})(window.Weglot);
